import React, { FC } from 'react';
import { Redirect } from 'react-router';

import { inIframe } from '@modernloop/shared/utils';

import { isValidWhitelistedReferrer } from 'src/utils/isValidWhitelistedReferrer';

const whitelistedReferrerDomains = ['rbx.com'];

/**
 * Guard that checks that the user is not in an iframe.
 * Note: Guards should check only one thing. Don't add any other checks to this Guard.
 */
const IPUserNotInIframeGuard: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { referrer } = document;

  // allow whitelisted referrers to pass through to be able to iFrame Interviewer Portal
  const isReferrerWhitelisted = whitelistedReferrerDomains.some((whitelistedReferrerDomain) =>
    isValidWhitelistedReferrer(referrer, whitelistedReferrerDomain)
  );

  if (inIframe() && !isReferrerWhitelisted) {
    return <Redirect to="/ip/extension" />;
  }

  // Don't add components here, please add components either on the app or on the appropriate Layout component
  return <>{children}</>;
};

export default IPUserNotInIframeGuard;
